export enum Routes {
    /**
     * ruta Default
     */
    DEFAULT = '/',

    // #region LOGIN
    /* MODULO LOGIN */
    /**
     * ruta Login
     */
    LOGIN = '/login',
    /**
     * ruta Post-Login selección de Rol/Perfil
     */
    POST_LOGIN_ROL = '/login/rol-selection',
    /**
     * ruta Validate password
     */
    VALIDATE_FOR_PASSWORD = '/login/resetear',
    // #endregion

    /**
 * ruta recovery password
 */
    FORGOT_PASSWORD = '/login/recuperar',
    // #endregion

    // #region REGISTRO
    /* REGISTRO */
    /**
     * ruta Registro
     */
    REGISTRO = '/registro',
    /**
     * ruta recovery password
     */
    OTP = '/login/recuperar/OTP',
    /**
     * ruta Registro Person
     */
    REGISTRO_PERSON = '/login/registro',
    /**
     * ruta Registro Persona
     */
    REGISTRO_PERSONA = '/registro/:persona',

    REGISTRO_PERSONA_FISICA = '/registro/pf',
    REGISTRO_PERSONA_JURIDICA = '/registro/pj',

    // Registro Persona Fisica - Ciudadano
    /**
     * ruta Registro De Identificacion Persona Fisica Ciudadano
     */
    REGISTRO_PERSONA_FISICA_CIUDADANO_IDENTIFICACION = '/registro/pf/ciudadano/identificacion',
    /**
     * ruta Registro De Credenciales Persona Fisica Ciudadano
     */
    REGISTRO_PERSONA_FISICA_CIUDADANO_CREDENCIALES = '/registro/pf/ciudadano/credenciales',
    /**
     * ruta Registro De OTP Persona Fisica Ciudadano
     */
    REGISTRO_PERSONA_FISICA_CIUDADANO_OTP = '/registro/pf/ciudadano/otp',
    /**
     * ruta Registro De Terminos y Condiciones Persona Fisica Ciudadano
     */
    REGISTRO_PERSONA_FISICA_CIUDADANO_TERMINOS = '/registro/pf/ciudadano/terminos-condiciones',

    // Registro Persona Fisica - Abogado
    /**
     * ruta Registro De Identificacion Persona Fisica Abogado
     */
    REGISTRO_PERSONA_FISICA_ABOGADO_IDENTIFICACION = '/registro/pf/abogado/identificacion',
    /**
     * ruta Registro De Datos Profesionales Persona Fisica Abogado
     */
    REGISTRO_PERSONA_FISICA_ABOGADO_DATOS_PROFESIONALES = '/registro/pf/abogado/datos-profesionales',
    /**
     * ruta Registro De Credenciales Persona Fisica Abogado
     */
    REGISTRO_PERSONA_FISICA_ABOGADO_CREDENCIALES = '/registro/pf/abogado/credenciales',
    /**
     * ruta Registro De OTP Persona Fisica Abogado
     */
    REGISTRO_PERSONA_FISICA_ABOGADO_OTP = '/registro/pf/abogado/otp',
    /**
     * ruta Registro De Terminos y Condiciones Persona Fisica Abogado
     */
    REGISTRO_PERSONA_FISICA_ABOGADO_TERMINOS = '/registro/pf/abogado/terminos-condiciones',

    // Registro Persona Jurídica - Gubernamental
    /**
     * ruta Registro De Identificacion Persona Jurídica Gubernamental
     */
    REGISTRO_PERSONA_JURIDICA_GUBERNAMENTAL_IDENTIFICACION = '/registro/pj/gubernamental/identificacion',
    /**
     * ruta Registro De Datos Persona Jurídica Gubernamental
     */
    REGISTRO_PERSONA_JURIDICA_GUBERNAMENTAL_DATOS = '/registro/pj/gubernamental/datos',
    /**
     * ruta Registro De Documentos Persona Jurídica Gubernamental
     */
    REGISTRO_PERSONA_JURIDICA_GUBERNAMENTAL_DOCUMENTOS = '/registro/pj/gubernamental/documentos',
    /**
     * ruta Registro De Contactos Persona Jurídica Gubernamental
     */
    REGISTRO_PERSONA_JURIDICA_GUBERNAMENTAL_CONTACTOS = '/registro/pj/gubernamental/contactos',
    /**
     * ruta Registro De Terminos y Condiciones Persona Jurídica Gubernamental
     */
    REGISTRO_PERSONA_JURIDICA_GUBERNAMENTAL_TERMINOS = '/registro/pj/gubernamental/terminos-condiciones',

    // Registro Persona Jurídica - Jurídica
    /**
     * ruta Registro De Identificacion Persona Jurídica
     */
    REGISTRO_PERSONA_JURIDICA_IDENTIFICACION = '/registro/pj/juridica/identificacion',
    /**
     * ruta Registro De Datos Persona Jurídica
     */
    REGISTRO_PERSONA_JURIDICA_DATOS = '/registro/pj/juridica/datos',
    /**
     * ruta Registro De Documentos Persona Jurídica
     */
    REGISTRO_PERSONA_JURIDICA_DOCUMENTOS = '/registro/pj/juridica/documentos',
    /**
     * ruta Registro De Contactos Persona Jurídica
     */
    REGISTRO_PERSONA_JURIDICA_CONTACTOS = '/registro/pj/juridica/contactos',
    /**
     * ruta Registro De Terminos y Condiciones Persona Jurídica
     */
    REGISTRO_PERSONA_JURIDICA_TERMINOS = '/registro/pj/juridica/terminos-condiciones',
    // #endregion

    // #region ESCRITORIO
    /* MODULO ESCRITORIO */
    /**
     * ruta Escritorio
     */
    ESCRITORIO = 'escritorio',
    /**
     * ruta Escritorio con slash
     */
    ESCRITORIO_SLASH = '/escritorio',
    // #endregion

    // #region CASOS
    /* MODULO CASOS */
    /**
     * ruta Casos
     */
    CASO = 'caso',
    /**
     * ruta Casos con slash
     */
    CASO_SLASH = '/caso',
    /**
     * ruta Casos con slash
     */
    CASO_CREAR = '/caso/crear',
    /**
     * ruta Ver Tramites
     */
    VER_TRAMITES = '/caso/ver-tramites',
    /**
     * ruta Ver Tramites con detalles
     */
    VER_TRAMITES_DETALLES = 'caso/vertramites/:id/detalles',
    /**
     * ruta para Detalles de un Trámite específico
     * Parámetros: :casoId, :tramiteId
     */
    TRAMITE_DETALLE = '/caso/:casoId/tramites/:tramiteId',
    // #endregion

    // #region AUDIENCIAS
    /* MODULO AUDIENCIAS */
    /**
     * ruta Audiencias
     */
    AUDIENCIAS = 'audiencias',
    /**
     * ruta Audiencias con slash
     */
    AUDIENCIAS_SLASH = '/audiencias',
    // #endregion

    // #region CALENDARIO
    /* MODULO CALENDARIO */
    /**
     * ruta Calendario
     */
    CALENDARIO = 'calendario',
    /**
     * ruta Calendario con slash
     */
    CALENDARIO_SLASH = '/calendario',
    // #endregion

    // #region ARCHIVOS - DOCUMENTOS
    /* MODULO archivos */
    /**
     * ruta archivos
     */
    ARCHIVOS = 'archivo',
    /**
     * ruta archivos con slash
     */
    ARCHIVOS_SLASH = '/archivo',
    // #endregion

    // #region ARCHIVO
    /* MODULO ARCHIVO */
    /**
     * ruta Archivo
     */
    ARCHIVO = 'archivo',
    /**
     * ruta Archivo con slash
     */
    ARCHIVO_SLASH = '/archivo',
    // #endregion

    // #region BUZON JUDICIAL
    /* MODULO BUZON JUDICIAL */
    /**
     * ruta Buzon Judicial
     */
    BUZON_JUDICIAL = 'buzon-judicial',
    /**
     * ruta Buzon Judicial con slash
     */
    BUZON_JUDICIAL_SLASH = '/buzon-judicial',
    // #endregion

    // #region EQUIPO
    /* MODULO EQUIPO */
    /**
     * ruta Equipo
     */
    EQUIPO = 'equipo',
    /**
     * ruta Equipo con slash
     */
    EQUIPO_SLASH = '/equipo',
    // #endregion

    // #region VU
    /* MODULO VU */
    /**
     * ruta VU
     */
    VU = '/vu',
    /**
     * ruta VU con slash
     */
    VALIDACION_USUARIO = '/validacion-usuario',
    // #endregion

    // #region SECURITY
    /* MODULO SECURITY */
    /**
     * ruta de confirmación de dispositivo
     * Parámetro: :token
     */
    DEVICE_CONFIRMATION = '/device/confirm/:token',
    /**
     * ruta de gestión de dispositivos
     */
    MY_DEVICES = '/settings/devices',
    // #endregion

}